/**
 * Asserts that a fetch Response is OK and contains JSON before calling .json().
 * Throws a descriptive error when the backend returns an HTML error page
 * (e.g. 502/503/WAF block), preventing the cryptic
 * "SyntaxError: Unexpected token '<'" in Server Components.
 */
export const assertJson = (res: Response): Response => {
    if (!res.ok) {
        throw new Error(
            `API error ${res.status} ${res.statusText} — url: ${res.url}`
        );
    }
    const ct = res.headers.get('content-type') ?? '';
    if (!ct.includes('application/json')) {
        throw new Error(
            `Expected JSON but received "${ct}" — url: ${res.url} (status ${res.status})`
        );
    }
    return res;
};

export const apiFetch = (url: string, options: any = {}): Promise<Response> => {

    const headers = {
        ...options.headers,
    };

    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/${url}`, {
        ...options,
        headers,
    }).then(assertJson);
};
